import { render } from "./UmwaLayout.vue?vue&type=template&id=2ece8eac"
import script from "./UmwaLayout.vue?vue&type=script&lang=js"
export * from "./UmwaLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__